import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {requestPOST, requestDELETE} from 'src/utils/baseAPI';
import {Spin} from 'antd';
import moment from 'moment';

import './ContentStyle.css';
import {createReleaseNotesPath} from 'src/utils/utils';

const ContentModelAI = (props) => {
  const {path} = useParams();
  const [dataFiles, setDataFiles] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await requestPOST(`api/v1/downloads/getfileserver`, {
          path: props?.pathAbsolute,
        });
        if (res) {
          setDataFiles(res ?? []);
        }
        setLoading(false);
        // setTimeout(() => {
        // }, 3000);
      } catch (error) {
        setLoading(false);
      }
    };

    fetchData();

    return () => {};
  }, [props]);
  const pathAbsolute = props?.pathAbsolute;

  return (
    <div className='container-download'>
      {loading && (
        <div className='container-spin'>
          {/* <div class='lds-hourglass'></div> */}
          <div id='loop' class='center'></div>
          <div id='bike-wrapper' class='center'>
            <div id='bike' class='centerBike'></div>
          </div>
        </div>
      )}

      <div className='black-line'></div>

      <div className='container-content'>
        <ul className='list-item'>
          <li className='itemfile'>
            <span>Tên phần mềm</span>
            <a className='btn-down'></a>
            <span style={{float: 'right', marginRight: '20px'}}>Kích thước</span>
            <span style={{float: 'right', marginRight: '20px'}}>Ngày tải lên</span>
          </li>
          {dataFiles &&
            dataFiles.map((item) => (
              <li className='itemfile'>
                <a
                  href={`https://download.smartparking.vn/${item?.path}`}
                  className='ahover'
                  download
                >
                  {item?.name}
                </a>

                <span style={{float: 'right', marginRight: '20px'}}>
                  {Math.round(item?.size / Math.pow(1024, 1))} MB
                </span>
                <span style={{float: 'right', marginRight: '20px'}}>
                  {moment(item?.createdOn).format('DD/MM/YYYY HH:mm')}
                </span>
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
};

export default ContentModelAI;
